import React from "react";
import { reviewProfile } from "../../../assets/images";
import { commaIcon } from "../../../assets/icons";
import Slider from "react-slick";

const ClientsReview = () => {
  // var settings = {
  //   dots: true,
  //   arrows: false,
  //   dots: false,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   fade: true,
  //   infinite: true,
  //   autoplay: true,
  //   speed: 2000,
  //   autoplaySpeed: 6000,
  // };
  return (
    <>
      <div className="client_satisfaction spacing">
        <div className="container">
          <div className="page_title">
            <h2>Our clients’ satisfaction is our top priority.</h2>
            <p>
              Real stories from women who trusted HolyPills for their care.
              Their journeys reflect the impact of reliable support, expert
              guidance, and homeopathic treatment.
            </p>
          </div>
          {/* <Slider {...settings}> */}
          <div className="review_card">
            <div className="image_wrap">
              <img src={reviewProfile} alt="profile-image" />
            </div>
            <div className="content">
              <p className="text">
                <img src={commaIcon} alt="icon" />
                “With Holypills , i have changed the way I manage my health. The
                app is so easy to use, and I love having access to a doctor
                whenever I need.”
              </p>
              <p className="auth">
                <b>Takshi Sharma </b>
                <span>Delhi, India</span>
              </p>
            </div>
          </div>
          {/* <div className="review_card">
              <div className="image_wrap">
                <img src={reviewProfile} alt="" />
              </div>
              <div className="content">
                <p className="text">
                  <img src={commaIcon} alt="" />
                  “Sophia has changed the way I manage my health. The app is so
                  easy to use, and I love having access to a doctor whenever I
                  need.”
                </p>
                <p className="auth">
                  <b>Daniel Kardashian </b>
                  <span>Los Angeles, CA</span>
                </p>
              </div>
            </div> */}
          {/* </Slider> */}
        </div>
      </div>
    </>
  );
};

export default ClientsReview;
